// extracted by mini-css-extract-plugin
export default {"wrapper":"default_wrapper__DqzUn","row":"default_row__LPc9L"};